const accordionComponents = () => {
  const $buttons = $('.accordion-btn');

  if (!$buttons.length) return;

  $buttons.on('click', function () {
    const $btn = $(this);
    const $box = $btn.parent();
    const $expand = $btn.next('.expand');
    const $icon = $btn.find('.accordion-icon');
    const $targets = $btn.add($expand).add($icon).add($box);
    const isOpen = $btn.hasClass('active');

    gsap.killTweensOf($expand);

    if (isOpen) {
      $targets.removeClass('active');
      gsap.to($expand, {
        height: 0,
        duration: 0.4,
        ease: 'circ.out',
        onComplete: () => ScrollTrigger.refresh(),
      });
      return;
    }

    gsap.set($expand, { height: 'auto' });
    const height = $expand.outerHeight();
    gsap.set($expand, { height: 0 });

    $targets.addClass('active');

    gsap.to($expand, {
      height,
      duration: 0.4,
      ease: 'circ.out',
      autoRound: false,
      onComplete: () => ScrollTrigger.refresh(),
    });
  });
};

export {
  accordionComponents
};
